/** Approval-path steps, in order (mirrors RequestDecisionStatusEnum on the API). */
export enum DecisionApprovalStep {
	Drafting = 1,
	FirstMemberNotes = 2,
	SecondMemberNotes = 3,
	ChairApproval = 4,
}
